import { Component, EventEmitter, HostBinding, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'crowdctrl-google-sign-in-button',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './google-sign-in-button.component.html',
  styleUrl: './google-sign-in-button.component.css',
})
export class GoogleSignInButtonComponent {
  /** When true, host and button span 100% of the parent (e.g. stacked login providers). */
  @Input() fullWidth = false;

  @HostBinding('class.google-sign-in-button--full-width')
  get hostFullWidth(): boolean {
    return this.fullWidth;
  }

  @Input() isLoading = false;
  @Input() disabled = false;
  @Input() text = 'Sign in with Google';
  @Input() loadingText = 'Signing in...';
  @Output() signIn = new EventEmitter<void>();

  onClick(): void {
    if (!this.isLoading && !this.disabled) {
      this.signIn.emit();
    }
  }
}
